import { Phone } from "lucide-react";
import { BUSINESS } from "../data/business";

export default function CtaBanner({ eyebrow = "Umów wizytę", title, subtitle }) {
  return (
    <section
      className="relative py-24 md:py-28 overflow-hidden bg-[var(--beautix-blush)]"
      data-testid="cta-banner"
    >
      <div className="absolute inset-0 grain" />
      <div className="relative max-w-4xl mx-auto text-center px-6">
        <p className="eyebrow mb-4">{eyebrow}</p>
        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mb-6">
          {title ||
            "Zapiszmy Twój termin już dziś."}
        </h2>
        <p className="text-lg text-[var(--beautix-muted)] mb-10 max-w-2xl mx-auto">
          {subtitle ||
            "Zadzwoń, żeby porozmawiać o Twoich potrzebach i wybrać idealny zabieg. Wolne terminy w salonie na Ligockiej."}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 items-center justify-center">
          <a
            href={`tel:${BUSINESS.phones[1].tel}`}
            data-testid="cta-mobile-phone"
            className="inline-flex items-center gap-3 bg-[var(--beautix-pink)] hover:bg-[var(--beautix-pink-dark)] text-white px-8 py-4 rounded-full text-sm font-medium tracking-wide transition-colors"
          >
            <Phone className="w-4 h-4" strokeWidth={1.5} />
            {BUSINESS.phones[1].number}
          </a>
          <a
            href={`tel:${BUSINESS.phones[0].tel}`}
            data-testid="cta-salon-phone"
            className="inline-flex items-center gap-3 border border-[var(--beautix-ink)]/60 text-[var(--beautix-ink)] hover:bg-white/60 px-8 py-4 rounded-full text-sm font-medium tracking-wide transition-colors"
          >
            Salon: {BUSINESS.phones[0].number}
          </a>
        </div>
      </div>
    </section>
  );
}
